module.exports = __webpack_public_path__ + "media/images/auth0_icons/auth0_lock_form_icon-a3047628defbe0da56173b2fc4c72705.png";